import { Know } from './Know'
import { TopicPath } from './Taxonomy'

export enum KnowExperimentVariants {
    SerpMetaRatingBaseline = 'serp_rating_variant_0',
    SerpMetaRatingVariant = 'serp_rating_variant_1',
    AiEnhancedBaseline = 'ai_enhanced_august_2024_variant_0',
    AiEnhancedVariant = 'ai_enhanced_august_2024_variant_1',
}

export interface KnowSeoInfo {
    know: Know
    title: string
    description: string
    experimentVariants: [x?: KnowExperimentVariants]
    transcript: string | null
    summary: string | null
    questions: { question: string; answer: string }[] | null
    topicsPath: TopicPath[]
    isEnhancedTranscript: boolean
    similarKnows: Know[]
    dislikesCount?: number | null
    seoPages: SeoPageSummary[] | null
}

interface SeoPageSummary {
    knowDocumentPageUuid: string
    summary: string
}
